<template>
  <div v-if="extra" :class="cls.extra" :style="rootStyle">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, type CSSProperties, type PropType } from 'vue'
import { useNamespace } from '@jdesign-vue/hooks'
import { createColorVars, STATISTIC_CARD_CLASSES } from '../constants'

interface ExtraConfig {
  content?: unknown
  divided?: boolean
}

export default defineComponent({
  name: 'StatisticCardExtra',
  props: {
    extra: { type: Object as PropType<ExtraConfig>, default: undefined },
  },
  setup(props) {
    const cls = STATISTIC_CARD_CLASSES
    const ns = useNamespace('statistic-card')
    const colorVars = createColorVars(ns.cssVarName)

    const rootStyle = computed<CSSProperties>(() => ({
      marginTop: '8px',
      paddingTop: props.extra?.divided ? '8px' : '0',
      borderTop: props.extra?.divided ? `1px solid ${colorVars.divider}` : undefined,
    }))

    return {
      cls,
      rootStyle,
    }
  },
})
</script>